import { render } from "./Register.vue?vue&type=template&id=71c8340e"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=71c8340e&lang=css"
script.render = render

export default script